"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const GButton = exports.GButton = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e1tm3r460"
} : {
  target: "e1tm3r460",
  label: "GButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1wexes1",
  styles: "display:grid;grid-template-columns:18px 1fr;grid-column-gap:24px;border:none;background-color:white;padding:11px;box-shadow:0px 0px 2px rgba(0, 0, 0, 0.12),0px 2px 2px rgba(0, 0, 0, 0.24);border-radius:2px;color:rgba(0, 0, 0, 0.54);font-family:'Roboto';font-weight:500;font-size:14px;cursor:pointer;align-items:center;&:focus{outline-color:rgba(66, 133, 244, 0.3);}&:active{background-color:#eeeeee;}"
} : {
  name: "1wexes1",
  styles: "display:grid;grid-template-columns:18px 1fr;grid-column-gap:24px;border:none;background-color:white;padding:11px;box-shadow:0px 0px 2px rgba(0, 0, 0, 0.12),0px 2px 2px rgba(0, 0, 0, 0.24);border-radius:2px;color:rgba(0, 0, 0, 0.54);font-family:'Roboto';font-weight:500;font-size:14px;cursor:pointer;align-items:center;&:focus{outline-color:rgba(66, 133, 244, 0.3);}&:active{background-color:#eeeeee;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});